export const CATEGORIES_LIST = [
  { label: 'Business and Professional', value: 'business_and_professional' },
  { label: 'Charity and Causes', value: 'charity_and_causes' },
  { label: 'Community and Culture', value: 'community_and_culture' },
  { label: 'Family and Education', value: 'family_and_education' },
  { label: 'Fashion and Beauty', value: 'fashion_and_beauty' },
  { label: 'Media and Entertainment', value: 'media_and_entertainment' },
  { label: 'Food and Drink', value: 'food_and_drink' },
  { label: 'Health and Wellness', value: 'health_and_wellness' },
  {
    label: 'Hobbies and Special Interest',
    value: 'hobbies_and_special_interest',
  },
  { label: 'Home and Lifestyle', value: 'home_and_lifestyle' },
  { label: 'Performing and Visual Arts', value: 'performing_and_visual_arts' },
  { label: 'Science and Technology', value: 'science_and_technology' },
  { label: 'Seasonal and Holiday', value: 'seasonal_and_holiday' },
  { label: 'Sports and Fitness', value: 'sports_and_fitness' },
  { label: 'Travel and Outdoor', value: 'travel_and_outdoor' },
  { label: 'Other', value: 'other' },
];

export const GUESTS_ROLES = {
  nonresident: 'nonresident',
  resident: 'resident',
  staff: 'staff',
};

export const EVENTS_STATUS_TYPES = [
  {
    label: 'Upcoming events',
    value: '1',
  },
  {
    label: 'Passed events',
    value: '0',
  },
];
